import { apiClient } from '../services/api-client';
import type { FoodUpdaterResponse } from '../types/food';

/**
 * PUTs to a foodcourt `/order/*` endpoint.
 *
 * The response is unvalidated JSON, so `TResponse` is an unchecked claim confined
 * to this boundary rather than validation — see the note in `LyticsFetcher`. It
 * defaults to {@link FoodUpdaterResponse} because every call site reads exactly
 * `statusCode` and `message` off the result.
 *
 * `body` is `unknown`: the call sites pass unrelated payloads (a whole `FoodOrder`, a
 * cancellation patch, a partially-deleted order) and it is serialised with
 * `JSON.stringify` without being read here.
 */
const FoodUpdater = async <TResponse = FoodUpdaterResponse>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResponse> => {
  const result = await apiClient.put<TResponse>(import.meta.env.VITE_FOODCOURT_API_NAME, endPoint, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: data,
  });
  return result;
};

export default FoodUpdater;
